/**
 * Couleur par famille de typologie de raccordement.
 *
 * Dix-huit valeurs circulent en production — RAC_I, RAC_C, RAC_P, RAC_F,
 * PTO_C, SAV, « RACC suite SAV (RAC_I) », REPRO_C, VT… Leur donner dix-huit
 * teintes rendrait le planning illisible : on colore la famille, et le suffixe
 * reste porté par le libellé, qui est déjà affiché.
 *
 * L'ordre des règles compte : « RACC suite SAV (RAC_C) » contient à la fois
 * SAV et RAC_, et doit se reconnaître avant les deux.
 */
const FAMILLES = [
  [/^racc\s*suite\s*sav/, 'reprise'],
  [/^repro/,              'repro'],
  [/^pto/,                'pto'],
  [/^vt\b/,               'vt'],
  [/^sav\b/,              'sav'],
  [/^rac[c_\-\s]?/,       'rac'],
];

export function familleTypo(nom) {
  const n = String(nom || '').trim().toLowerCase();
  if (!n) return 'autre';
  const f = FAMILLES.find(([re]) => re.test(n));
  return f ? f[1] : 'autre';
}

/** Les trois teintes d'une typologie, prises dans la palette du thème actif. */
export function couleurTypo(nom) {
  const f = familleTypo(nom);
  return {
    fond:  `var(--typo-${f}-fond)`,
    texte: `var(--typo-${f}-texte)`,
    bord:  `var(--typo-${f}-bord)`,
  };
}

/** Pastille de typologie, identique dans le planning et dans le bilan. */
export function styleTypo(nom) {
  const c = couleurTypo(nom);
  return {
    fontSize: 11, fontWeight: 700, borderRadius: 6, padding: '2px 8px',
    background: c.fond, color: c.texte, border: `1px solid ${c.bord}`,
    whiteSpace: 'nowrap',
  };
}
